import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@babel/polyfill'
import VConsole from 'vconsole'
import reuseHeader from '@/components/reuseHeader.vue'
import reuseLoading from '@/components/reuseLoading.vue'
import reuseAgreement from '@/components/reuseAgreement.vue'
import '@/utils/vant'
import '@/utils/reuseDot'
import 'amfe-flexible'
import javaNative from '@/utils/javaNative'
import VueClipboard from 'vue-clipboard2'
import './filters'

Vue.use(javaNative)
Vue.use(VueClipboard)

// 通用打点
function reuseDot (pageName, action, extInfo) {
  this.$reuseDot({
    pageName,
    action,
    extInfo
  })
}
Vue.prototype.reuseDot = reuseDot

Vue.component('reuseHeader', reuseHeader)
Vue.component('reuseLoading', reuseLoading)
Vue.component('reuseAgreement', reuseAgreement)
Vue.config.productionTip = false
// 调式工具 开发环境才会开启
const isDev = process.env.NODE_ENV === 'development'
isDev && new VConsole()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
